import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule, Routes} from '@angular/router';
import {AdModule} from '@components/ad/ad.module';
import {RendementComponent} from './rendement/rendement.component';
import {VilleComponent} from './ville/ville.component';
import {NewComponent} from './new/new.component';
import {UrlComponent} from './url/url.component';
import { ImpotComponent } from './impot/impot.component';

const tabs = [
    {
        slug: 'rendement',
        title: 'Rendement',
        template: '1/1',
        kpi: [
            'total-loyer',
            'total-sortie',
            'cash-flow',
            'rendement-brut',
            'rendement-net',
        ],
        col1: [
            'config-rendement-tools',
        ],
        col2: [],
        col3: [],
    },
    {
        slug: 'ville',
        title: 'Analyse ville',
        template: '1/1-1',
        kpi: [
            'change-city',
            'habitant',
            'city-square-price',
            'price-city-evol',
            'city-efficiency',
        ],
        col1: [
            'config-city-tools',
            'population',
            'prix-moyen',
            'population-activity',
            'commodite-ville',
            'pyramide-ages',
            'etudiant',
            'menages',
            'entreprises',
            'services-ville',
        ],
        col2: [
            'evol-prix-immo',
            'city-map',
            'repartition',
            'loyer-moyen',
            'tensiometre',
            'ville-lien',
            'commerces',
            'logements',
            'tourisme',
        ],
        col3: [],
    },
    {
        slug: 'new',
        title: 'Nouveau projet',
        template: '2-1',
        kpi: [],
        col1: [
            'config-project-tools',
        ],
        col2: [],
        col3: [],
    },
    {
        slug: 'url',
        title: 'Analyser un lien',
        template: '1',
        kpi: [],
        col1: [
            'config-project-url',
        ],
        col2: [],
        col3: [],
    },
    // {
    //     slug: 'travaux',
    //     title: 'Estimation travaux',
    //     template: '1/1',
    //     kpi: [],
    //     col1: [
    //         'project',
    //     ],
    //     col2: [],
    //     col3: [],
    // }
];

const toolsRoutes: Routes = [
    {path: '', redirectTo: 'rendement'},
    {path: 'rendement', component: RendementComponent, data: {tabs, tab: tabs[0]}},
    {path: 'ville', component: VilleComponent, data: {tabs, tab: tabs[1]}},
    {path: 'ville/:code', component: VilleComponent, data: {tabs, tab: tabs[1]}},
    {path: 'new', component: NewComponent, data: {tabs, tab: tabs[2]}},
    {path: 'url', component: UrlComponent, data: {tabs, tab: tabs[3]}},
    {path: 'impot', component: ImpotComponent, data: {tabs: [], tab:
        {
            slug: 'impot',
            title: 'Simulateur de fiscalité',
            template: '1',
            kpi: [],
            col1: [
                'config-impots-tools',
                'config-impots',
            ],
            col2: [],
            col3: [],
        }
    }},
];


@NgModule({
    declarations: [RendementComponent, VilleComponent, NewComponent, UrlComponent, ImpotComponent],
    imports: [
        CommonModule,
        RouterModule.forChild(toolsRoutes),
        AdModule,
    ]
})
export class ToolsModule {
}
